var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSso1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.16,
    y1: 0.064,
    x2: 0.86,
    y2: 0.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dacf35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b3802"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 64,
    height: 64,
    transform: "translate(16376 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sso",
    transform: "translate(-16376 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_272",
    "data-name": "Union 272",
    d: "M15.648,58.715A6.058,6.058,0,0,1,20.284,52.1V45.843H7.8V52.1a6.053,6.053,0,0,1,4.63,6.614A6.173,6.173,0,0,1,6.242,64,6.175,6.175,0,0,1,.051,58.715,6.051,6.051,0,0,1,4.677,52.1V45.843A3.073,3.073,0,0,1,7.8,42.821H20.284V37.826a19.886,19.886,0,0,1-5.792-1.408,19.572,19.572,0,0,1-6.229-4.061,18.886,18.886,0,0,1-4.2-6.025,18.44,18.44,0,0,1,0-14.756,18.854,18.854,0,0,1,4.2-6.023,19.542,19.542,0,0,1,6.229-4.063,20.276,20.276,0,0,1,15.253,0,19.637,19.637,0,0,1,6.228,4.063,18.916,18.916,0,0,1,4.2,6.023,18.469,18.469,0,0,1,0,14.756,18.941,18.941,0,0,1-4.2,6.025,19.667,19.667,0,0,1-6.228,4.061A19.93,19.93,0,0,1,23.4,37.868v4.953H35.885A3.069,3.069,0,0,1,39,45.843V52.1a6.053,6.053,0,0,1,4.632,6.614,6.27,6.27,0,0,1-12.383,0A6.054,6.054,0,0,1,35.885,52.1V45.843H23.4V52.1a6.053,6.053,0,0,1,4.632,6.614,6.271,6.271,0,0,1-12.385,0Zm18.674-.785a3.123,3.123,0,1,0,3.122-3.021A3.075,3.075,0,0,0,34.323,57.931Zm-15.6,0a3.123,3.123,0,1,0,3.12-3.021A3.074,3.074,0,0,0,18.721,57.931Zm-15.6,0a3.075,3.075,0,0,0,3.122,3.024,3.024,3.024,0,1,0,0-6.045A3.074,3.074,0,0,0,3.12,57.931ZM16.8,13.575a2.038,2.038,0,0,0,2.068,2h1.185v4.1A7.565,7.565,0,0,0,16.8,21.536a7.126,7.126,0,0,0,0,10.309,7.708,7.708,0,0,0,10.643,0,7.131,7.131,0,0,0,0-10.309,7.6,7.6,0,0,0-3.253-1.855V5.934a2.07,2.07,0,0,0-4.138,0v.453H18.865a2,2,0,1,0,0,4.007h1.185v1.177H18.865A2.038,2.038,0,0,0,16.8,13.575Zm1.93,13.117a3.391,3.391,0,1,1,3.391,3.281A3.341,3.341,0,0,1,18.727,26.692Z",
    transform: "translate(16386.156 1488)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSso1);
export default __webpack_public_path__ + "static/media/ic_sso_1.3430888c9651c9987e326d5273a126c3.svg";
export { ForwardRef as ReactComponent };